import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { FaHome, FaArrowRight, FaRocket } from 'react-icons/fa';
import './NotFound.css';

const NotFound = () => (
  <>
    <Helmet>
      <title>404 - Page Not Found | Amresh Prajapati</title>
      <meta name="robots" content="noindex" />
    </Helmet>

    <section className="notfound">
      <div className="notfound__grid" />
      <div className="notfound__glow notfound__glow--one" />
      <div className="notfound__glow notfound__glow--two" />

      <div className="notfoundContainer notfound__inner">
        <motion.div
          className="notfound__content"
          initial={{ opacity: 0, y: 36, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{ duration: 0.65 }}
        >
          <span className="notfound__tag">
            <FaRocket /> Page Missing
          </span>

          <div className="notfound__code">404</div>

          <h1>Oops! This Page Got Lost</h1>

          <p>
            The page you’re looking for doesn’t exist, has been moved,
            or the link may be incorrect.
          </p>

          <div className="notfound__actions">
            <Link to="/" className="notfoundBtn notfoundBtn--primary">
              <FaHome /> Go Home
            </Link>

            <Link to="/contact" className="notfoundBtn notfoundBtn--outline">
              Contact Me <FaArrowRight />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  </>
);

export default NotFound;